import React, { useState } from 'react';
import { 
  FaImages, 
  FaCamera, 
  FaHeartbeat, 
  FaHospital, 
  FaUserMd, 
  FaPlus,
  FaTimes,
  FaChevronLeft,
  FaChevronRight
} from 'react-icons/fa';

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showAll, setShowAll] = useState(false);
  const [activeCategory, setActiveCategory] = useState('All');

  const galleryCategories = [
    { name: "All", count: 8 },
    { name: "Medical Procedures", count: 5 },
    { name: "Clinic Facilities", count: 2 },
    { name: "Doctor At Work", count: 1 }
  ];

  const galleryImages = [
    {
      url: "https://images.tv9hindi.com/wp-content/uploads/2025/02/cancer-pic.jpg",
      category: "Medical Procedures",
      title: "Advanced Cancer Treatment",
      description: "State-of-the-art cancer treatment facilities"
    },
    {
      url: "https://www.cancertherapyadvisor.com/wp-content/uploads/sites/12/2023/01/patient-with-cancer_G_939771318.jpg",
      category: "Medical Procedures",
      title: "Patient Consultation",
      description: "Expert consultation with Dr. Shukla"
    },
    {
      url: "https://taelimalhurufalearabia.com/wp-content/uploads/2025/01/a.webp",
      category: "Clinic Facilities",
      title: "Modern Operation Theater",
      description: "Advanced surgical facilities"
    },
    {
      url: "https://resize.indiatv.in/resize/newbucket/1200_-/2025/07/back-pain-kidney-cancer-09-07-2025-1752040936.jpg",
      category: "Medical Procedures",
      title: "Kidney Cancer Care",
      description: "Specialized kidney cancer treatment"
    },
    {
      url: "https://d3uigcfkiiww0g.cloudfront.net/wordpress/blog/pics-en/uploads/ColorectalCancer.png",
      category: "Medical Procedures",
      title: "Cancer Awareness",
      description: "Educational resources for patients"
    },
    {
      url: "https://urologyaustin.com/wp-content/uploads/2018/07/iStock-531985630.jpg",
      category: "Clinic Facilities",
      title: "Urology Department",
      description: "Specialized urology care unit"
    },
    {
      url: "https://tse1.explicit.bing.net/th/id/OIP.NtnlJ4nlapB6dTlJKAmqKgHaEj?w=650&h=400&rs=1&pid=ImgDetMain&o=7&rm=3",
      category: "Doctor At Work",
      title: "Surgical Excellence",
      description: "Precision in surgical procedures"
    },
    {
      url: "https://media.sciencephoto.com/image/f0234974/800wm/F0234974-Illustration_of_a_human_cancer_cell.jpg",
      category: "Medical Procedures",
      title: "Cancer Research",
      description: "Advanced cancer cell research"
    }
  ];

  const displayedImages = showAll 
    ? (activeCategory === 'All' 
      ? galleryImages 
      : galleryImages.filter(img => img.category === activeCategory))
    : (activeCategory === 'All' 
      ? galleryImages.slice(0, 4) 
      : galleryImages.filter(img => img.category === activeCategory).slice(0, 4));

  const handleImageClick = (image, index) => {
    setSelectedImage(image);
    setCurrentIndex(galleryImages.findIndex(img => img.url === image.url));
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  const handleNext = () => {
    const nextIndex = (currentIndex + 1) % galleryImages.length;
    setCurrentIndex(nextIndex);
    setSelectedImage(galleryImages[nextIndex]);
  };

  const handlePrev = () => {
    const prevIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    setCurrentIndex(prevIndex);
    setSelectedImage(galleryImages[prevIndex]);
  };

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
    setShowAll(false);
  };

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center mb-4">
            <div className="w-12 h-12 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 flex items-center justify-center mr-3">
              <FaImages className="text-white text-xl" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
              Our <span className="text-blue-600">Gallery</span>
            </h2>
          </div>
          
          <div className="w-32 h-1 bg-gradient-to-r from-blue-400 to-blue-600 rounded-full mx-auto mb-6"></div>
          
          <p className="text-gray-600 max-w-2xl mx-auto">
            Explore our state-of-the-art facilities, advanced medical procedures, and moments of excellence in patient care
          </p>
        </div>

        <div className="mb-8">
          <div className="flex flex-wrap justify-center gap-3">
            {galleryCategories.map((category, index) => (
              <button 
                key={index}
                onClick={() => handleCategoryClick(category.name)}
                className={`px-5 py-2 rounded-full font-medium transition-all duration-300 flex items-center ${
                  activeCategory === category.name
                    ? 'bg-gradient-to-r from-blue-500 to-blue-700 text-white shadow-lg'
                    : 'bg-white border border-gray-300 text-gray-700 hover:border-blue-500 hover:text-blue-600'
                }`}
              >
                {category.name}
                <span className={`ml-2 text-xs px-2 py-1 rounded-full ${
                  activeCategory === category.name
                    ? 'bg-white/30 text-white'
                    : 'bg-gray-100 text-gray-600'
                }`}>
                  {category.count}
                </span>
              </button>
            ))}
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {displayedImages.map((image, index) => (
            <div 
              key={index}
              className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 cursor-pointer"
              onClick={() => handleImageClick(image, index)}
            >
              <div className="relative aspect-square overflow-hidden">
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110"
                  onError={(e) => {
                    e.target.src = `https://via.placeholder.com/400x400/0ea5e9/ffffff?text=${encodeURIComponent(image.title)}`;
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  <div className="absolute top-3 left-3">
                  <span className="bg-black/60 backdrop-blur-sm text-white text-xs px-3 py-1 rounded-full">
                    {image.category}
                  </span>
                </div>
                
                <div className="absolute top-3 right-3 w-8 h-8 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <FaPlus className="text-white text-sm" />
                </div>
                  <div className="absolute bottom-0 left-0 right-0 p-4 transform translate-y-full group-hover:translate-y-0 transition-transform duration-500">
                  <h3 className="text-white font-bold text-sm md:text-base mb-1">
                    {image.title}
                  </h3>
                  <p className="text-gray-300 text-xs">
                    {image.description}
                  </p>
                </div>
              </div>
              
              <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-0 h-1 bg-gradient-to-r from-blue-400 to-blue-600 rounded-full transition-all duration-500 group-hover:w-3/4"></div>
            </div>
          ))}
        </div>
        {!showAll && (
          <div className="text-center mt-8">
            <button 
              onClick={() => setShowAll(true)}
              className="px-8 py-3 bg-gradient-to-r from-white to-gray-50 text-blue-600 rounded-lg font-semibold border-2 border-blue-200 hover:border-blue-400 hover:bg-blue-50 transition-all duration-300 transform hover:-translate-y-1 flex items-center mx-auto"
            >
              <FaCamera className="mr-2" />
              View All Gallery ({galleryImages.length})
            </button>
          </div>
        )}

        {showAll && (
          <div className="text-center mt-8">
            <button 
              onClick={() => setShowAll(false)}
              className="px-8 py-3 bg-gradient-to-r from-blue-50 to-white text-blue-600 rounded-lg font-semibold border-2 border-blue-300 hover:border-blue-500 hover:bg-blue-100 transition-all duration-300 transform hover:-translate-y-1 flex items-center mx-auto"
            >
              Show Less
            </button>
          </div>
        )}

        <div className="text-center mt-4 text-gray-500 text-sm">
          Showing {displayedImages.length} of {galleryImages.length} images
        </div>
      </div>

      {selectedImage && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm">
          <div className="relative max-w-6xl w-full mx-4">
            <button
              onClick={handleCloseModal}
              className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors duration-300 z-10"
            >
              <FaTimes className="text-2xl" />
            </button>
            
            <button
              onClick={handlePrev}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/30 transition-all duration-300"
            >
              <FaChevronLeft />
            </button>
            
            <button
              onClick={handleNext}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/30 transition-all duration-300"
            >
              <FaChevronRight />
            </button>
              <div className="bg-white rounded-2xl overflow-hidden shadow-2xl">
              <div className="relative h-[60vh]">
                <img
                  src={selectedImage.url}
                  alt={selectedImage.title}
                  className="w-full h-full object-contain"
                />
              </div>
              
              <div className="p-6 bg-gradient-to-r from-gray-50 to-white">
                <div className="flex items-center mb-3">
                  <span className="bg-blue-100 text-blue-600 text-xs px-3 py-1 rounded-full mr-3">
                    {selectedImage.category}
                  </span>
                  <span className="text-gray-500 text-sm">
                    {currentIndex + 1} / {galleryImages.length}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {selectedImage.title}
                </h3>
                <p className="text-gray-600">
                  {selectedImage.description}
                </p>
              </div>
            </div>
                <div className="flex justify-center mt-6 space-x-2 overflow-x-auto pb-2">
              {galleryImages.map((img, index) => (
                <button
                  key={index}
                  onClick={() => {
                    setSelectedImage(img);
                    setCurrentIndex(index);
                  }}
                  className={`flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden border-2 transition-all duration-300 ${
                    currentIndex === index
                      ? 'border-blue-500 scale-110'
                      : 'border-transparent opacity-70 hover:opacity-100'
                  }`}
                >
                  <img
                    src={img.url}
                    alt={`Thumbnail ${index + 1}`}
                    className="w-full h-full object-cover"
                  />
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default GallerySection;